import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import { connect } from 'react-redux'

const useStyles = makeStyles({

});

const Index = ({
  notification,

  disabled,
}) => {
  const classes = useStyles();

  return (
    <>
      <Card elevation={disabled ? 0 : 4}>
        <CardActionArea disabled={disabled}>
          <CardContent>
            <Typography gutterBottom variant="h5">
              {notification?.title}
            </Typography>
            <Typography variant="subtitle">
              {notification?.body}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({

})

export default connect(
  mapStateToProps,
  {
  }
)(Index);
